
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waianapanapa/about",
      function () {
        return require("private-next-pages/waianapanapa/about.js");
      }
    ]);
  